export const getClients = (state) => {
    return state.clients;
};

export const getDepartments = (state) => {
    return state.departments;
};

export const getDistricts = (state) => {
    return state.districts;
};

export const getCultivationTypes = (state) => {
    return state.cultivation_types;
};

export const getWarehouses = (state) => {
    return state.warehouses;
};

export const getSafras = (state) => {
    return state.safras;
};

export const getProtocols = (state) => {
    return state.protocols;
};

export const getProperties = (state) => {
    return state.properties;
};

export const getAvailableBalance = (state) => {
    return state.availableBalance;
};

export const getVolumeAdded = (state) => {
    return state.form.properties.reduce(
        (acc, property) => acc + Number(property.volume),
        0
    );
};

export const getVolumeRemaining = (state) => {
    return (
        state.form.contract_data.volume -
        state.form.properties.reduce(
            (acc, property) => acc + Number(property.volume),
            0
        )
    );
};

export const getVolumePercentage = (state, getters) => {
    if (getters.getVolumeAdded > state.form.contract_data.volume) {
        return 0;
    }

    return (getters.getVolumeAdded / state.form.contract_data.volume || 0) * 100;
};

export const getReportList = (state) => {
    return state.reportList;
};

export const getOperationList = (state) => {
    return state.operationList;
};

export const getReport = (state) => {
    return state.report;
};

export const getContractDistrict = (state) => {
    return state.form.contract_data.district;
};

export const getUserPermission = (state, getters, rootState) => {
    return rootState.usuarioLogado.authorities.map((item) => item.authority);
};

export const isRegistrant = (state, getters) => {
    return getters.getUserPermission.includes('ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE');
};

export const isApprover = (state, getters) => {
    return getters.getUserPermission.includes('ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR');
};

export const isContractOwner = (state, getters, rootState) => {
    return state.report.client === rootState.usuarioLogado.idGrupo;
};

export const isContractDataValid = (state) => {
    return state.form.contract_data.contract_number &&
    state.form.contract_data.volume &&
    state.form.contract_data.cultivation_id &&
    state.form.contract_data.department &&
    state.form.contract_data.district &&
    state.form.contract_data.client_id &&
    state.form.contract_data.contract_date;
};
